import { safetyStatementsHeader, safetyStatementsHeaderUser } from "@/pages/Accounting/SafetyStatements/constants";
import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";

export default {
	state: {
		safetyStatementsData: null,
		safetyStatementsList: [],
		safetyStatementsFilterList: null,
		safetyStatementsItem: null,
		safetyStatementsCreateList: null,
		safetyStatementsView: null,
		safetyStatementsCreateFilter: {},
		dispatcherStatementsCreateView: null
	},
	mutations: {
		updateListAfterRemoveSafetyStatement(state, id) {
			const idx = state.safetyStatementsList.findIndex(item => item.id === id);
			if (idx !== -1) state.safetyStatementsList.splice(idx, 1);
		},
		updateItem(state, row) {
			const idx = state.safetyStatementsList.findIndex(item => item.id === row.id);
			state.safetyStatementsList.splice(idx, 1, row);
		},
		updateSafetyStatementsList(state, { statement, filter }) {
			state.safetyStatementsList = statement;
			state.safetyStatementsFilterList = filter;

		},
		updateSafetyStatementsCreateList(state, { rows, month, dispatcher_rate, filter }) {
			state.safetyStatementsItem = { month, dispatcher_rate };
			state.safetyStatementsCreateList = rows;
			state.safetyStatementsCreateFilter = filter;
		},
		updateSafetyStatementsView(state, payload) {
			state.safetyStatementsView = payload;
		},
		updateDispatcherStatementsCreateView(state, payload) {
			state.dispatcherStatementsCreateView = payload;
		}
	},
	actions: {
		async getSafetyStatementsList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/safety-statement');
				if (data) {
					commit('updateSafetyStatementsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.SAFETY, defaultHeader: safetyStatementsHeader });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async getSafetyStatementsListUser({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/safety-statement');
				if (data) {
					commit('updateSafetyStatementsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.SAFETY, defaultHeader: safetyStatementsHeaderUser });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onSafetyStatementsCreate({ commit, dispatch }, { id, ...values }) {
			const uri = id ? `/safety-statement/${ id }/edit` : '/safety-statement/create';
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(uri);
				if (data) {
					if (id) {
						const { rows, period } = data;
						commit('updateSafetyStatementsView', { rows, period, ...values });
					} else {
						commit('updateSafetyStatementsCreateList', data);
					}
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onSafetyStatementsCreateFilter({ commit, dispatch }, values) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post('/safety-statement/create/list', values);

				if (data) {
					commit('updateSafetyStatementsCreateList', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onSafetyStatementsRate({ dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/safety-statement/rate', values);
				if (data && data.status) {
					dispatch("setAlert", { type: "success", message: "Save rate Successfully" });
				} else {
					dispatch("setAlert", { type: "error", message: "Saving error" });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onSafetyStatementsSave({ dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/safety-statement', values);

				if (data && data.status) {
					await dispatch('getSafetyStatementsList');
					dispatch('setAlert', { type: "success", message: "Save Successfully" });
				} else {
					dispatch('setAlert', { type: "error", message: "Saving error" });
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onSafetyStatementsFilter({ commit, dispatch }, values) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post('/safety-statement/list', values);

				if (data) {
					commit('updateSafetyStatementsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.SAFETY, defaultHeader: safetyStatementsHeader });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onSafetyStatementsFilterUser({ commit, dispatch }, values) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post('/safety-statement/list', values);

				if (data) {
					commit('updateSafetyStatementsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.SAFETY, defaultHeader: safetyStatementsHeaderUser });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onSafetyStatementsCreateView({ commit, dispatch }, values) {

			const { user_id, date, type } = values;
			try {
				dispatch("actionPreloader", true);
				if (type) {
					const { data } = await httpClient.post(`/safety-statement/create/${ user_id }/${ date }/list`, { type } );
					if (data) {
						const { rows, period } = data;
						commit('updateSafetyStatementsView', { rows, period, ...values });
					}
				} else {
					const { data } = await httpClient.post(`/safety-statement/create/${ user_id }/${ date }/list`);
					if (data) {
						const { rows, period } = data;
						commit('updateSafetyStatementsView', { rows, period, ...values });
					}
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onDispatcherStatementsCreateView({ commit, dispatch }, values) {
			try {
				const { data } = await httpClient.post(`/dispatcher/statement/info`, values);
				if (data) {
					console.log('%c [  data  ] ', 'color:#bada55', typeof data, data );
					// dispatch("setAlert", { type: "success", message: "Item removed successfully" });
					commit('updateDispatcherStatementsCreateView', data);
				} else {
					dispatch("setAlert", { type: "error", message: "Deleted Error" });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onRemoveSafetyStatements({ commit, dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/safety-statement/${ id }`);
				if (data && data.status) {
					commit('updateListAfterRemoveSafetyStatement', id);
					dispatch("setAlert", { type: "success", message: "Item removed successfully" });
				} else {
					dispatch("setAlert", { type: "error", message: "Deleted Error" });
				}
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {
		safetyStatementsList: (s) => s.safetyStatementsList,
		safetyStatementsData: (s) => s.safetyStatementsData,
		safetyStatementsFilterList: (s) => s.safetyStatementsFilterList,
		safetyStatementsCreateList: s => s.safetyStatementsCreateList,
		safetyStatementsCreateFilter: s => s.safetyStatementsCreateFilter,
		safetyStatementsView: s => s.safetyStatementsView,
		safetyStatementsItem: s => s.safetyStatementsItem,
		dispatcherStatementsCreateView: s => s.dispatcherStatementsCreateView,
	},
};
